import type { Client } from '@src/clients/domain/Client';
import { Drawer } from '@src/common/components/Drawer';
import { PageLayout } from '@src/common/components/Page';
import { useToast } from '@src/common/hooks/useToast';
import type { Tractor } from '@src/tractor/domain/Tractor';
import { useTractor } from '@src/tractor/hooks/useTractor';
import { useUpdateTractor } from '@src/tractor/hooks/useUpdateTractor';
import { TractorPageForm } from '@src/tractor/TractorPageForm';
import { useTranslation } from 'react-i18next';

interface Props {
  client: Client;
  tractorId: string;
  isOpen: boolean;
  onClose: () => void;
  onUpdate: (updatedTractor: Tractor) => void;
}
export const EditTractorDrawer = ({
  client,
  onClose,
  isOpen,
  onUpdate,
  tractorId,
}: Props) => {
  const { t } = useTranslation();
  const { showSuccessToast, showErrorToast } = useToast();
  const { tractor, isLoading: isLoadingTractor } = useTractor(
    client.id,
    tractorId,
  );

  const { updateTractor, isLoading } = useUpdateTractor({
    clientId: client.id,
    tractor: tractor!,
    onSuccess: (newTractor) => {
      onUpdate(newTractor);
      showSuccessToast(t('updateTractor.success'));
    },
    onError: () => {
      showErrorToast(t('updateTractor.error'));
    },
  });

  return (
    <Drawer open={isOpen} onClose={onClose} width="90vw">
      {!isLoadingTractor && tractor && (
        <PageLayout title={t('editTractor')}>
          <TractorPageForm
            onSubmit={updateTractor}
            onCancel={onClose}
            isLoading={isLoading}
            prefillData={tractor}
          />
        </PageLayout>
      )}
    </Drawer>
  );
};
